(function () {
    /**
     * Trick for tag name changing.
     * Actually, we copy content of the old element to a new element(with new tag name) and replace old one
     * @param {string|string} newTagName - new tag name
     * @returns {*|jQuery|HTMLElement}
     */
    $.fn.changeTagName = function (newTagName) {
        // create the new, empty shim
        if (!newTagName || !_.isString(newTagName) || newTagName.length <= 0) {
            return this;
        }
        var replacement = $('<' + _.str.trim(_.str.dasherize(newTagName), "_-") + '>');
        // empty container to hold attributes
        var attributes = {};
        // copy all the attributes to the shell
        $.each(this.get(0).attributes, function (index, attribute) {
            attributes[attribute.name] = attribute.value;
        });
        // assign attributes to replacement
        replacement.attr(attributes);
        // copy the data
        replacement.data(this.data());
        // get all the kids, with data and events
        var contents = this.contents().clone(true);
        // inseminate
        replacement.append(contents);
        // swap it out
        this.replaceWith(replacement);
        // and we're done
        return replacement;
    };

    /**
     * Get HTML of element and it's content
     * @returns {string} outer HTML
     */
    $.fn.outerHtml = function () {
        return jQuery('<div />').append(this.eq(0).clone()).html();
    };
})();


/**
 * Easing for jquery animate
 */
(function () {
    jQuery.easing['jswing'] = jQuery.easing['swing'];

    jQuery.extend(jQuery.easing,
        {
            def: 'easeOutQuad',
            swing: function (x, t, b, c, d) {
                return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
            },
            easeInQuad: function (x, t, b, c, d) {
                return c * (t /= d) * t + b;
            },
            easeOutQuad: function (x, t, b, c, d) {
                return -c * (t /= d) * (t - 2) + b;
            },
            easeInOutQuad: function (x, t, b, c, d) {
                if ((t /= d / 2) < 1) return c / 2 * t * t + b;
                return -c / 2 * ((--t) * (t - 2) - 1) + b;
            },
            easeInCubic: function (x, t, b, c, d) {
                return c * (t /= d) * t * t + b;
            },
            easeOutCubic: function (x, t, b, c, d) {
                return c * ((t = t / d - 1) * t * t + 1) + b;
            },
            easeInOutCubic: function (x, t, b, c, d) {
                if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
                return c / 2 * ((t -= 2) * t * t + 2) + b;
            },
            easeInQuart: function (x, t, b, c, d) {
                return c * (t /= d) * t * t * t + b;
            },
            easeOutQuart: function (x, t, b, c, d) {
                return -c * ((t = t / d - 1) * t * t * t - 1) + b;
            },
            easeInOutQuart: function (x, t, b, c, d) {
                if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
                return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
            },
            easeInQuint: function (x, t, b, c, d) {
                return c * (t /= d) * t * t * t * t + b;
            },
            easeOutQuint: function (x, t, b, c, d) {
                return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
            },
            easeInOutQuint: function (x, t, b, c, d) {
                if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
                return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
            },
            easeInSine: function (x, t, b, c, d) {
                return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
            },
            easeOutSine: function (x, t, b, c, d) {
                return c * Math.sin(t / d * (Math.PI / 2)) + b;
            },
            easeInOutSine: function (x, t, b, c, d) {
                return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
            },
            easeInExpo: function (x, t, b, c, d) {
                return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
            },
            easeOutExpo: function (x, t, b, c, d) {
                return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
            },
            easeInOutExpo: function (x, t, b, c, d) {
                if (t == 0) return b;
                if (t == d) return b + c;
                if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
                return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
            },
            easeInCirc: function (x, t, b, c, d) {
                return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
            },
            easeOutCirc: function (x, t, b, c, d) {
                return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
            },
            easeInOutCirc: function (x, t, b, c, d) {
                if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
                return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
            },
            easeInElastic: function (x, t, b, c, d) {
                var s = 1.70158;
                var p = 0;
                var a = c;
                if (t == 0) return b;
                if ((t /= d) == 1) return b + c;
                if (!p) p = d * .3;
                if (a < Math.abs(c)) {
                    a = c;
                    s = p / 4;
                }
                else {
                    s = p / (2 * Math.PI) * Math.asin(c / a);
                }
                return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
            },
            easeOutElastic: function (x, t, b, c, d) {
                var s = 1.70158;
                var p = 0;
                var a = c;
                if (t == 0) return b;
                if ((t /= d) == 1) return b + c;
                if (!p) p = d * .3;
                if (a < Math.abs(c)) {
                    a = c;
                    s = p / 4;
                }
                else {
                    s = p / (2 * Math.PI) * Math.asin(c / a);
                }
                return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
            },
            easeInOutElastic: function (x, t, b, c, d) {
                var s = 1.70158;
                var p = 0;
                var a = c;
                if (t == 0) return b;
                if ((t /= d / 2) == 2) return b + c;
                if (!p) p = d * (.3 * 1.5);
                if (a < Math.abs(c)) {
                    a = c;
                    s = p / 4;
                }
                else {
                    s = p / (2 * Math.PI) * Math.asin(c / a);
                }
                if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
                return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
            },
            easeInBack: function (x, t, b, c, d, s) {
                if (s == undefined) s = 1.70158;
                return c * (t /= d) * t * ((s + 1) * t - s) + b;
            },
            easeOutBack: function (x, t, b, c, d, s) {
                if (s == undefined) s = 1.70158;
                return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
            },
            easeInOutBack: function (x, t, b, c, d, s) {
                if (s == undefined) s = 1.70158;
                if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
                return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
            },
            easeInBounce: function (x, t, b, c, d) {
                return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
            },
            easeOutBounce: function (x, t, b, c, d) {
                if ((t /= d) < (1 / 2.75)) {
                    return c * (7.5625 * t * t) + b;
                } else if (t < (2 / 2.75)) {
                    return c * (7.5625 * (t -= (1.5 / 2.75)) * t + .75) + b;
                } else if (t < (2.5 / 2.75)) {
                    return c * (7.5625 * (t -= (2.25 / 2.75)) * t + .9375) + b;
                } else {
                    return c * (7.5625 * (t -= (2.625 / 2.75)) * t + .984375) + b;
                }
            },
            easeInOutBounce: function (x, t, b, c, d) {
                if (t < d / 2) return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * .5 + b;
                return jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
            }
        });
})();


/* jQuery touch gestures.
 *
 * Copyright (c) technoweenie (https://github.com/technoweenie/jquery.doubletap/blob/master/lib/jquery.doubletap.js)
 */
(function ($) {

    var defaults = {
        'swipeTolerance': 40
    };

    var touchStatus = function (target, touch) {
        this.target = $(target);
        this.touch = touch;
        this.startX = this.currentX = touch.screenX;
        this.startY = this.currentY = touch.screenY;
        this.eventType = null;
    };
    touchStatus.options = {};
    touchStatus.latestTap = null;

    touchStatus.prototype.move = function (touch) {
        this.currentX = touch.screenX;
        this.currentY = touch.screenY;
    };

    touchStatus.prototype.process = function () {
        var offsetX = this.currentX - this.startX;
        var offsetY = this.currentY - this.startY;
        if (offsetX == 0 && offsetY == 0) {
            this.checkForDoubleTap();
        } else if (Math.abs(offsetY) > touchStatus.options.swipeTolerance && Math.abs(offsetY) > Math.abs(offsetX)) {
            this.eventType = offsetY > 0 ? 'swipedown' : 'swipeup';
            this.target.trigger('swipe', [this]);
        } else if (Math.abs(offsetX) > touchStatus.options.swipeTolerance) {
            this.eventType = offsetX > 0 ? 'swiperight' : 'swipeleft';
            this.target.trigger('swipe', [this]);
        }
        if (this.eventType) this.target.trigger(this.eventType, [this]);
        this.target.trigger('touch', [this]);
    };

    touchStatus.prototype.checkForDoubleTap = function () {
        if (touchStatus.latestTap) {
            if ((new Date() - touchStatus.latestTap) < 400) {
                this.eventType = 'doubletap';
            }
        }
        if (!this.eventType) this.eventType = 'tap';
        touchStatus.latestTap = new Date();
    };

    var swipeEvents = function (elements, options) {
        touchStatus.options = $.extend(defaults, options);
        elements.bind('touchstart', this.touchStart);
        elements.bind('touchmove', this.touchMove);
        elements.bind('touchcancel', this.touchCancel);
        elements.bind('touchend', this.touchEnd);
    };

    swipeEvents.prototype.touchStart = function (evt) {
        var target = this;
        swipeEvents.eachTouch(evt, function (touch) {
            swipeEvents.touches[touch.identifier] = new touchStatus(target, touch);
        });
    };

    swipeEvents.prototype.touchMove = function (evt) {
        swipeEvents.eachTouch(evt, function (touch) {
            var loc = swipeEvents.touches[touch.identifier];
            if (loc) loc.move(touch);
        });
    };

    swipeEvents.prototype.touchCancel = function (evt) {
        swipeEvents.eachTouch(evt, function (touch) {
            swipeEvents.purge(touch, true);
        });
    };

    swipeEvents.prototype.touchEnd = function (evt) {
        swipeEvents.eachTouch(evt, function (touch) {
            swipeEvents.purge(touch);
        });
    };

    swipeEvents.touches = {};
    swipeEvents.purge = function (touch, cancelled) {
        if (!cancelled) {
            var loc = swipeEvents.touches[touch.identifier];
            if (loc) loc.process();
        }
        delete swipeEvents.touches[touch.identifier];
    };

    swipeEvents.eachTouch = function (evt, callback) {
        var evt = evt.originalEvent;
        var num = evt.changedTouches.length;
        for (var i = 0; i < num; i++) {
            callback(evt.changedTouches[i]);
        }
    };

    // adds custom events:
    //   touch      // all events
    //   swipe      // only swipe* events
    //   swipeleft
    //   swiperight
    //   swipeup
    //   swipedown
    //   tap
    //   doubletap
    $.fn.addSwipeEvents = function (options, callback) {
        if (!callback && jQuery.isFunction(options)) {
            callback = options;
            options = null;
        }
        new swipeEvents(this, options);
        if (callback) this.bind('touch', callback);
        return this;
    };
})(jQuery);